import { provideHttpClient, withInterceptors } from '@angular/common/http';
import type { ApplicationConfig } from '@angular/core';
import { mergeApplicationConfig } from '@angular/core';
import { provideClientHydration, withEventReplay, withI18nSupport } from '@angular/platform-browser';

import { provideThemeDbSync } from '@arya/account/settings/preferences/data-access';
import { provideSessionKeepalive } from '@arya/auth/data-access';
import { providePwaUpdate } from '@arya/shared/feature';

import { APP_CONFIG } from './app.config';
import { DEV_HTTP_INTERCEPTORS } from './dev-surfaces';
import { withAuthenticatedHttpTransferCache } from './http-transfer-cache';
import { provideThemeStorageGuard } from './provide-theme-storage-guard';

export const browserConfig: ApplicationConfig = {
  providers: [
    provideClientHydration(withEventReplay(), withI18nSupport(), withAuthenticatedHttpTransferCache()),
    provideThemeStorageGuard(),
    provideHttpClient(withInterceptors(DEV_HTTP_INTERCEPTORS)),
    providePwaUpdate(),
    provideThemeDbSync(),
    provideSessionKeepalive(),
  ],
};

export const APP_CONFIG_BROWSER = mergeApplicationConfig(APP_CONFIG, browserConfig);
